/* rk-gifvid: animated-GIF replacement videos (muted loop). First video (data-rk-vid-first) plays at once; the rest get their src
   400px before they scroll into view and pause offscreen. Reduce-motion: poster only. */
(function () {
  if (window.rkLazyVid) return; window.rkLazyVid = true;
  function init() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var first = document.querySelectorAll('video[data-rk-vid-first]');
    first.forEach(function (v) {
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); return; }
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    });
    var vids = document.querySelectorAll('video[data-rk-lazyvid]');
    if (!vids.length || reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (!v.getAttribute('src')) { v.src = v.getAttribute('data-src'); v.load(); }
          var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
        } else if (v.getAttribute('src')) { v.pause(); }
      });
    }, { rootMargin: '400px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
